module.exports = __webpack_public_path__ + "img/download-circle-white.b743e83c.svg";